import { CartProduct } from '@mc/api'
import { CERT_CREDIT_ADD_ON_SLUG } from './constants'

/**
 * Splits the certs-quiz cart into its two lines.
 *
 * Picked by identity rather than by position. `carts_controller` sorts lines by
 * CartProduct::PRODUCT_TYPES, so products[0] is the subscription today, but that leaves
 * a row silently describing the wrong product the moment a line sorts unexpectedly.
 *
 * The certificate is matched by slug, NEVER by `productType`: ours is
 * `add_on_subscription`, which the Learning Toolkit and On Call add-ons carry too, so a
 * type match would print a Learning Toolkit line under the certificate's label. The
 * backend discriminates the same way (`PurchasePlan#is_cert_credit_add_on?`).
 *
 * `isSubscription` is server-derived (`Product#is_subscription`, true only for a
 * PurchasePlan asset), so it still matches a legacy line carrying no `product_type`.
 */
export const getCertsLines = (products: CartProduct[] = []) => ({
  membership: products.find(({ isSubscription }) => isSubscription),
  certificate: products.find(
    ({ courseSlug }) => courseSlug === CERT_CREDIT_ADD_ON_SLUG,
  ),
})
